import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={`relative overflow-hidden text-slate-400 hover:text-slate-200 hover:bg-slate-800 ${className}`}
      data-testid="app-theme-toggle"
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${isDark ? 'opacity-100' : 'opacity-0'}`}>
        <Moon className="w-4 h-4" />
      </div>
      <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${isDark ? 'opacity-0' : 'opacity-100'}`}>
        <Sun className="w-4 h-4" />
      </div>
    </Button>
  );
};

export default ThemeToggle;
